import axios from './axiosInstance';

export const variationsList = async (params = {}) => {
  const response = await axios.get("/club_api/exercise_collections", { params });
  return response.data;
};

export const variationDetails = async (id) => {
  const response = await axios.get("/club_api/exercise_collections/" + id);
  return response.data;
};

export const copyVariation = async (id) => {
  const response = await axios.get("/club_api/exercise_collections/" + id + "/copy");
  return response.data;
};

export const saveVariation = async (exercise_collection) => {
  const response = !exercise_collection?.id
    ? await axios.post("/club_api/exercise_collections/", { exercise_collection } )
    : await axios.put("/club_api/exercise_collections/" + exercise_collection.id, { exercise_collection } );
    return response.data;
};

export const variationCategoriesList = async () => {
  const response = await axios.get("/club_api/exercise_collections/categories" );
  return response.data;
};

export const removeVariation= async (id) => {
  const response = await axios.delete(`/club_api/exercise_collections/${id}`);
  return response.data;
};